import { UpdateDocumentStatus } from 'domain/usecases/document/update-document-status'
import { UpdateEligibilityDocument } from 'domain/usecases/eligibility/update-eligibility-document'
import { EligibilityRepository } from 'repository/repositories/eligibility/eligibility-repository'

export class RemoteUpdateEligibility implements UpdateEligibilityDocument {
  constructor(private readonly eligibilityDocument: EligibilityRepository) {}

  async update(
    params: UpdateEligibilityDocument.Params
  ): Promise<UpdateEligibilityDocument.Model> {
    return await this.eligibilityDocument.updateDocumentStatus(params)
  }
}

export type UpdateDocumentStatusModel = UpdateDocumentStatus.Model
